const toolTipData = [
  "Average value of product sold daily over the past 90 days",
  "Average value of product sold daily over the past 30 days",
  "Average value of product sold daily over the past 7 days",
  "Sales trend in the last 7 days compared to the last 90 days. This shows if the sales are trending upwards or dropping"
];
export default toolTipData;
